import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CompaniesService {


  constructor(private http: HttpClient) { }

  url = environment.serverAPI9 + '/' + 'api/companyEntity';

  url1 = environment.serverAPI9 + '/' + 'api/companyEntity/exceltemplate';

  url3 = environment.serverAPI9 + '/' + 'api/companyEntity/solr';

  url10 = environment.serverAPI9 + '/' + 'api/companyEntity';

  url22 = environment.serverAPI9 + '/api';

  url11 = environment.serverAPI9 + '/api/housing/leads';

  url6 = environment.serverAPI4 + '/' + 'api/product';

  url13 = environment.serverAPI + "/api/lead/approve";

  url14 = environment.serverAPI9 + '/api/lead';

  url15 = environment.serverAPI9 + '/api/company';

  addlead(leadEntity): Observable<Response[]> {
    return this.http.post<Response[]>(`${this.url}`, leadEntity);
  }

  getLeadById(entityId: number): Observable<Object> {
    return this.http.get(`${this.url}/db/${entityId}`);
  }

  downloadLeadReport(id: any): Observable<any> {
    return this.http.get(`${this.url1}/export/${id}`, { responseType: 'arraybuffer', observe: 'response' });
  }


  getAllLeadDetailsByEntityId(leadId: number): Observable<Object> {
    return this.http.get(`${this.url}/solr/${leadId}`);
  }

  editLead(leadEntity, leadId: number): Observable<Response[]> {
    return this.http.post<Response[]>(`${this.url}/edit/${leadId}`, leadEntity);
  }

  excelImportLead(data: FormData, id: any): Observable<Object> {
    return this.http.post(`${this.url1}/upload/${id}`, data);
  }

  leadAlreadyExist(payload): Observable<any> {
    return this.http.post(`${this.url}/check/exist`, payload);
  }

  getCompany(Page: any, size: any, sort: any): Observable<Object> {
    return this.http.get(`${this.url3}?page=${Page}&size=${size}&sort=${sort}`);
  }

  getCompanyBySearch(query, Page: any, size: any, sort: any): Observable<Object> {
    return this.http.get(`${this.url10}/filter?search=${query}&page=${Page}&size=${size}&sort=${sort}`);
  }

  deleteAllCompany(): Observable<Object> {
    return this.http.delete(`${this.url10}`);
  }


  sendWhatsAppMessage(phoneNumbersList: any, templateId: any): Observable<any> {

    return this.http.post(`${this.url22}/whatsapp/send/message/${templateId}`, phoneNumbersList);
  }

  addOrEditHousingLeadData(housing: any): Observable<Response[]> {
    return this.http.post<Response[]>(`${this.url11}`, housing);
  }

  deleteByLeadId(id: any): Observable<Object> {
    return this.http.delete(`${this.url10}/${id}`);
  }

  downloadCompanyReportPrimary(Page: number, size: number,
    sort, selectionLead): Observable<any> {
    return this.http.post(`${this.url6}/export/page?page=${Page}
		&size=${size}&sort=${sort}`, selectionLead, {
      responseType: 'arraybuffer',
      observe: 'response'
    });
  }

  deleteBySelectedId(deleteProductist): Observable<Response[]> {
    return this.http.post<Response[]>(`${this.url10}/delete/selected`, deleteProductist);
  }

  updateLeadStatus(LeadList: any, status: any): Observable<Response[]> {
    return this.http.post<Response[]>(`${this.url10}/update/leadStatus/${status}`, LeadList);
  }

  getApproved(leadCustomer: any): Observable<Object> {
		return this.http.post(`${this.url13}`, leadCustomer);
	}

    getAllCompaniessByEntityId(Page: any, size: any, sort: any, companyId:any): Observable<Object> {
    return this.http.get(`${this.url14}/linked/company/${companyId}?page=${Page}&size=${size}&sort=${sort}`);
  }

  getAllCompaniessByEntityIdNew(Page: any, size: any, sort: any, companyId:any): Observable<Object> {
    return this.http.get(`${this.url15}/linked/${companyId}?page=${Page}&size=${size}&sort=${sort}`);
  }


  addCompanyAdvanced(companyies: any): Observable<Response[]> {
    return this.http.post<Response[]>(`${this.url}/upload/advanced`, companyies);
  }

    addCompanyName(lead: any): Observable<Response[]> {
    return this.http.post<Response[]>(`${this.url}/add/new`, lead);
  }
 getAllCompainesAllByLeadId(leadId: number): Observable<Object> {
    return this.http.get(`${this.url}/solr/all/${leadId}`);
  }


  
  getCompanyBySearchAll(query, Page: any, size: any, sort: any): Observable<Object> {
    return this.http.get(`${this.url10}/solr/all?search=${query}&page=${Page}&size=${size}&sort=${sort}`);
  }

  getNotificationStatus(notificationId: any): Observable<any> {
    return this.http.get(`${environment.serverAPI4}/api/adminNotification/${notificationId}`);
  }

}
